import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Calendar from '@/components/calendar/Calendar'

export const calendar = [
	{
		path: '/calendar',
		beforeEnter: ifAuthenticatedOnline,
		component: Calendar,
		props: {
			modelDef: 'calendar',
			'action-icon': 'event',
			title: 'Calendario'
		}
	},
]
